// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"246":"7faad541","312":"ce590a59","453":"b90086cf"}[chunkId] + ".chunk.js";
};